<section class="kit-grupo" *ngIf="config" [class.kit-grupo--completo]="completo">
  <header class="kit-grupo__cabecalho">
    <div class="kit-grupo__titulo">
      <h3>{{grupo.nome}}</h3>
      <span class="kit-pill" *ngIf="estado.qtdeUnidades">{{estado.qtdeUnidades}} un.</span>
    </div>
    <p class="kit-grupo__regras">
      <ng-container *ngIf="config.modalidadeQuantidade === 'FIXA'">Distribua {{config.qtdeFixa}} unidades entre as opções.</ng-container>
      <ng-container *ngIf="config.modalidadeQuantidade !== 'FIXA'">Escolha a quantidade e distribua entre as opções.</ng-container>
      <ng-container *ngIf="config.qtdeMinimaPorOpcao > 1"> Mínimo de {{config.qtdeMinimaPorOpcao}} por opção.</ng-container>
      <ng-container *ngIf="config.qtdeMaximaDeOpcoes"> Até {{config.qtdeMaximaDeOpcoes}} opções diferentes.</ng-container>
    </p>
  </header>

  <div class="kit-escolha" *ngIf="config.modalidadeQuantidade === 'FECHADA'">
    <span class="kit-escolha__rotulo">Quantidade</span>
    <div class="kit-chips">
      <button type="button" class="kit-chip" *ngFor="let q of quantidades" (click)="escolhaQuantidade(q.id)"
              [class.kit-chip--selecionado]="estado.quantidadeFechadaId === q.id">
        <strong>{{q.descricao}}</strong>
        <span>{{q.qtdeUnidades}} un.<ng-container *ngIf="config.cobranca === 'POR_QUANTIDADE'"> · {{q.preco | currency:'BRL'}}</ng-container></span>
      </button>
    </div>
  </div>

  <div class="kit-escolha" *ngIf="config.modalidadeQuantidade === 'ESCOLHIDA_PELO_CLIENTE'">
    <div class="kit-escolha__linha">
      <div class="kit-escolha__texto">
        <span class="kit-escolha__rotulo">Quantas unidades?</span>
        <small class="kit-escolha__dica">De {{config.incremento}} em {{config.incremento}} · mínimo {{config.qtdeMinima}}<ng-container *ngIf="config.qtdeMaxima != null"> · máximo {{config.qtdeMaxima}}</ng-container></small>
      </div>
      <div class="kit-stepper kit-stepper--destaque">
        <button type="button" [attr.aria-label]="'Diminuir ' + config.incremento + ' unidades'" (click)="passoUnidades(-1)" [disabled]="!podeDiminuirUnidades">−{{config.incremento}}</button>
        <input type="number" inputmode="numeric" aria-label="Unidades do grupo" [ngModel]="estado.qtdeUnidades" (ngModelChange)="definaUnidades($event)"
               [min]="config.qtdeMinima" [max]="config.qtdeMaxima" [step]="config.incremento">
        <button type="button" [attr.aria-label]="'Aumentar ' + config.incremento + ' unidades'" (click)="passoUnidades(1)" [disabled]="!podeAumentarUnidades">+{{config.incremento}}</button>
      </div>
    </div>
    <div class="kit-chips kit-chips--atalhos" *ngIf="atalhos.length > 1">
      <button type="button" class="kit-chip kit-chip--compacto" *ngFor="let n of atalhos" (click)="definaUnidades(n)"
              [class.kit-chip--selecionado]="estado.qtdeUnidades === n">{{n}}</button>
    </div>
    <p class="kit-escolha__preco" *ngIf="config.cobranca === 'POR_QUANTIDADE' && estado.qtdeUnidades">
      {{precoGrupo | currency:'BRL'}} <small>por {{estado.qtdeUnidades}} unidades</small>
    </p>
  </div>

  <div class="kit-sabores__topo">
    <span class="kit-sabores__rotulo">{{passoRapido > 1 ? 'Toque para somar de ' + passoRapido + ' em ' + passoRapido + ' ou digite' : 'Toque ou digite a quantidade'}}</span>
    <button type="button" class="kit-link" (click)="dividir()" [disabled]="!estado.qtdeUnidades">Dividir igualmente</button>
  </div>

  <ul class="kit-sabores">
    <li class="kit-sabor" *ngFor="let o of opcoes" [class.kit-sabor--ativo]="quantidade(o) > 0">
      <div class="kit-sabor__info">
        <span class="kit-sabor__nome">{{o.nome}}</span>
        <small class="kit-sabor__extra" *ngIf="o.valor">+ {{o.valor | currency:'BRL'}} por unidade</small>
        <button type="button" class="kit-link kit-sabor__completar" *ngIf="restante > 0" (click)="completar(o)">
          {{quantidade(o) > 0 ? 'Completar com mais ' + restante : 'Completar com ' + restante}}
        </button>
      </div>
      <div class="kit-stepper">
        <button type="button" [attr.aria-label]="'Diminuir ' + o.nome" (click)="passo(o,-1)" [disabled]="quantidade(o) <= 0">{{passoRapido > 1 ? '−' + passoRapido : '−'}}</button>
        <input type="number" inputmode="numeric" [attr.aria-label]="'Quantidade de ' + o.nome" [ngModel]="quantidade(o)" (ngModelChange)="definir(o,$event)" min="0" step="1">
        <button type="button" [attr.aria-label]="'Aumentar ' + o.nome" (click)="passo(o,1)" [disabled]="restante <= 0">{{passoRapido > 1 ? '+' + passoRapido : '+'}}</button>
      </div>
    </li>
  </ul>

  <footer class="kit-resumo" aria-live="polite" [class.kit-resumo--completo]="completo" [class.kit-resumo--alerta]="!!aviso || (!completo && total > 0)">
    <div class="kit-barra"><span [style.width.%]="progresso"></span></div>
    <div class="kit-resumo__linha">
      <strong>{{total}} de {{estado.qtdeUnidades || 0}} unidades</strong>
      <span class="kit-resumo__status" role="status">{{statusTexto}}</span>
    </div>
  </footer>
</section>
